import {
  Button,
  Modal,
} from "@twinkltech/curriculum-architect-component-library";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { COMMON_NS } from "@/i18n/common/common.i18n";
import { paths } from "@/paths";

import { SESSION_EXPIRED_MODAL_NS } from "./SessionExpiredModal.i18n";

export const SessionExpiredModal = () => {
  const { t } = useTranslation(SESSION_EXPIRED_MODAL_NS);
  return (
    <Modal open hasCloseButton={false} width="sm" onClose={() => {}}>
      <Modal.Header>
        <Modal.Title>{t("session_expired")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{t("session_expired_message")}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          as={Link}
          rel="noreferrer noopener"
          to={paths.external.TWINKL_LOGIN_URL()}
          variant="primary"
        >
          {t("actions.login", { ns: COMMON_NS })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
